import React, {useState, useEffect, useRef, useContext} from 'react';
import util from 'common/util'
import {MapContext} from '_context/MapContext';
import {ollehModule} from '../../common/mapAPIExport'
import { getItem } from '_services/agent';

const RPProcess = (props) => {
    const currRoute = useRef()
    const currRoutes = useRef() 
    const currBound = useRef() 
    const currNearMarkers = useRef() 
    const {ktMapIns, routes, selectedTbt, setSelectedTbt, rpOpts, nearPoi, selectedId, selectedPoi, opts, changeRPStart, changeRPEnd, changeRPWayPoint, setRpDrag} = useContext(MapContext);
    const outCenterDraw = useRef(true)

    useEffect(() => {
        nearPoiClear()
        if(nearPoi && nearPoi.pois) poiDisplay()
    }, [nearPoi]);

    useEffect(() => {
        if(routes && routes.length>0){
            infoWindowOpen(null)
            routeMapDisplay();
        }else{
            mapClear()
            nearPoiClear()
        }
    }, [routes]);

    useEffect(() => {
        poiMapFocus()
    }, [selectedId]);

    useEffect(() => {
        if(routes && routes.length>0){
            currRoute.current = currRoutes.current['rpType_' + rpOpts.rpType]
            if(currRoute.current){
                onTopDraw()
            }
        }
    }, [rpOpts.rpType]);

    useEffect(() => {
        if(routes && routes.length>0){
            tbtMapFocus()
        }
    }, [selectedTbt]);

    useEffect(() => {
        if(routes && routes.length>0){
            infoWindowOpen(null)
            allBound()
        }
    }, [rpOpts.routeViewAll]);

    const routeMapDisplay= ()=>{
        mapClear()
        currRoutes.current = {}
        outCenterDraw.current = routes[2].distance<200000
        let minX = 9999999, minY = 9999999, maxX = -9999999, maxY = -9999999;
        routes.some((route, idx) => {
            if(rpOpts.rpType===route.rpType){
                currRoute.current = route
            }
            currRoutes.current['rpType_' + route.rpType] = route
            let utmkArr = [];
            let num = 0;
            route.links.some((link, linkIdx) => {
                let nodes = link.nodes.slice(0, link.nodes.length-1)
                if(route.links.length-1 === idx){
                    nodes = link.nodes
                }
                nodes.some((node, nodeIdx) => {
                    num++
                    node.x<minX ? minX=node.x : minX=minX
                    node.y<minY ? minY=node.y : minY=minY
                    node.x>maxX ? maxX=node.x : maxX=maxX
                    node.y>maxY ? maxY=node.y : maxY=maxY
                    let utmk = new ollehModule.maps.UTMK(node.x, node.y)
                    utmk['linkNum'] = linkIdx
                    utmk['nodeNum'] = nodeIdx
                    utmk['linkPart'] = 'c'
                    if(nodeIdx===0){
                        utmk['roadName'] = link.roadName
                        utmk['linkPart'] = 's'
                    }
                    if(nodes.length-1 === nodeIdx){
                        utmk['linkPart'] = 'e'
                    }
                    utmk['num'] = num
                    utmkArr.push(utmk)
                })
            })
            currBound.current = {minX:minX, minY:minY, maxX:maxX, maxY:maxY}
            makePolyline(utmkArr, route.rpType)
            makeMarker(route)
        })
        allBound()
        onTopDraw()
    }

    const makePolyline = (utmkArr, rpType)=>{
        let polyline = new ollehModule.maps.vector.Polyline({map: null, path:new ollehModule.maps.Path(utmkArr), strokeColor:'rgb(177,188,199)', strokeWeight:8}) 
        let polyline_outline = new ollehModule.maps.vector.Polyline({map: null, path:new ollehModule.maps.Path(utmkArr), strokeColor:'rgb(17,17,17)', strokeWeight:10, strokeOpacity:0.6}) 
        let polyline_centerLine = new ollehModule.maps.vector.Polyline({map: null, path:new ollehModule.maps.Path(utmkArr), strokeColor:'#ffffff', strokeWeight:1, strokeStyle:'longdash'}) 
        currRoutes.current['rpType_' + rpType]['polyline'] = polyline
        currRoutes.current['rpType_' + rpType]['polyline_outline'] = polyline_outline
        currRoutes.current['rpType_' + rpType]['polyline_centerLine'] = polyline_centerLine
    }

    const makeMarker = (route)=>{
        currRoutes.current['rpType_' + route.rpType]['markers'] = []
        let wayPointCnt = 0
        route.tbts.some((tbt, idx) => {
            let marker = makerMatch(tbt, tbt.type, idx)
            marker['idx'] = idx
            marker['attribute'] = tbt
            marker.onEvent('click', function(e) {
                e.stopPropagation()
                props.tbtClick(e, idx)
                infoWindowOpen(marker)
            });
            if(tbt.type===998 || tbt.type===999 || tbt.type===1999|| tbt.type===1000 || tbt.type===2000){
                if(tbt.type===1000 || tbt.type===2000){
                    marker['wayPointCnt'] = wayPointCnt
                    wayPointCnt++;
                }
                marker.onEvent('dragend', function(e) {
                    let latLng = util.utmkToLatlng(marker._position.x, marker._position.y) 
                    let fi = {'lng': latLng.y, 'lat': latLng.x}
                    getItem('geocode','?point.lat='+latLng.x+'&point.lng='+latLng.y, null, 'GET').then(res => {
                        let keyworkd = ''
                        if(res.data.residentialAddress[0].roadAddress && res.data.residentialAddress[0].roadAddress.length>0){
                            keyworkd = res.data.residentialAddress[0].roadAddress[0]
                        }
                        if(!keyworkd){
                            if(res.data.residentialAddress[0].parcelAddress && res.data.residentialAddress[0].parcelAddress.length>0){
                                keyworkd = res.data.residentialAddress[0].parcelAddress[0]
                            }
                        }
                        if(keyworkd){
                            if(tbt.type===998){
                                changeRPStart(fi, keyworkd.fullAddress)
                            }else if(tbt.type===999 || tbt.type===1999){
                                changeRPEnd(fi, keyworkd.fullAddress)
                            }else{
                                changeRPWayPoint(fi, keyworkd.fullAddress, marker['wayPointCnt'])
                            }
                            setRpDrag(true)
                        }
                    })
                    
                });
            }
            currRoutes.current['rpType_' + route.rpType]['markers'].push(marker)
        })
        let makerArr = currRoutes.current['rpType_' + route.rpType]['markers']
        makerArr.some((marker, idx) => {
            if(idx+1<makerArr.length){
                marker['next'] = makerArr[idx+1]
            }
            if(idx!=0){
                marker['prev'] = makerArr[idx-1]
            }
        })
    }

    const makerMatch = (tbt, tbtType, idx)=>{
        if(tbtType===998){
            return new ollehModule.maps.overlay.CustomMarker({position: new ollehModule.maps.UTMK(tbt.tbtLinkX, tbt.tbtLinkY), map:null, className:'markerBg_custom route start', label:tbt.displayName, draggable: true});
        }else if(tbtType===999 || tbtType===1999){
            return new ollehModule.maps.overlay.CustomMarker({position: new ollehModule.maps.UTMK(tbt.tbtLinkX, tbt.tbtLinkY), map:null, className:'markerBg_custom route finish', label:tbt.displayName, draggable: true});
        }else if(tbtType===1000 || tbtType===2000){
            return new ollehModule.maps.overlay.CustomMarker({position: new ollehModule.maps.UTMK(tbt.tbtLinkX, tbt.tbtLinkY), map:null, className:'markerBg_custom route wayPoint', label:tbt.displayName, draggable: true});
        }else{
            let icon = {url:'https://map.gis.kt.com/assets/images/marker_num_'+idx+'.png', size: new ollehModule.maps.Size(19, 19), anchor: new ollehModule.maps.Point(19/2, 19/2)}
            return new ollehModule.maps.overlay.Marker({position: new ollehModule.maps.UTMK(tbt.tbtLinkX, tbt.tbtLinkY), icon:icon, map:null});
        }
    }

    const allBound = ()=>{
        ktMapIns['rpBound'] = new ollehModule.maps.Bounds(new ollehModule.maps.UTMK(currBound.current.minX, currBound.current.minY), new ollehModule.maps.UTMK(currBound.current.maxX, currBound.current.maxY))
        ktMapIns.fitBounds(ktMapIns['rpBound']);
        let boundTimer = setInterval(function() {
            clearInterval(boundTimer);
            try{
                let xgap = (ktMapIns.layerMgr.getCoordFromLayerPx(new ollehModule.maps.Point(396, 0)).x - ktMapIns.layerMgr.getCoordFromLayerPx(new ollehModule.maps.Point(0, 0)).x)/2;
                let xRgap = (ktMapIns.layerMgr.getCoordFromLayerPx(new ollehModule.maps.Point(70, 0)).x - ktMapIns.layerMgr.getCoordFromLayerPx(new ollehModule.maps.Point(0, 0)).x)/2;
                ktMapIns['rpBound'] = new ollehModule.maps.Bounds(new ollehModule.maps.UTMK(currBound.current.minX-xgap, currBound.current.minY), new ollehModule.maps.UTMK(currBound.current.maxX+xgap+xRgap, currBound.current.maxY))
                ktMapIns.fitBounds(ktMapIns['rpBound']);
                var currCenter = ktMapIns.getCenter();
                currCenter.x = currCenter.x - xgap;
                ktMapIns.setCenter(currCenter);
            }catch(e){
                clearInterval(boundTimer);
            }
        },500)
    }

    const onTopDraw = ()=>{
        let polyline = null
        for (let [key, route] of Object.entries(currRoutes.current)) {
            if(currRoute.current!=route){
                shapeObjectReset(route['polyline_outline'], outCenterDraw.current)
                polyline = route['polyline']
                polyline._opts.strokeColor = 'rgb(177,188,199)'
                shapeObjectReset(polyline, outCenterDraw.current)
                shapeObjectReset(route['polyline_centerLine'], false)
                route['markers'].some((marker) => {
                    shapeObjectReset(marker, false)
                })
            }
        }
        
        shapeObjectReset(currRoute.current['polyline_outline'], outCenterDraw.current)
        polyline = currRoute.current['polyline']
        polyline._opts.strokeColor = '#7725ff'
        shapeObjectReset(polyline)
        shapeObjectReset(currRoute.current['polyline_centerLine'], outCenterDraw.current)
        currRoute.current['markers'].some((marker) => {
            shapeObjectReset(marker)
        })
    }

    const shapeObjectReset = (shapeObj, topMode=true)=>{
        shapeObj.setMap(null)
        if(topMode){
            shapeObj.setMap(ktMapIns)
        }
    }

    const poiDisplay = () => {
        nearPoiClear()
        currNearMarkers.current = []
        nearPoi.pois.forEach((element, idx) => {
            let latLngPoint = new ollehModule.maps.LatLng(element.point.lat, element.point.lng);
            let point = ollehModule.maps.UTMK.valueOf(latLngPoint);
            let marker = new ollehModule.maps.overlay.CustomMarker({
                position: point,
                map:ktMapIns,
                label:(idx+1)+''
            });
            marker['attribute'] = element
            marker.id = element.id
            marker.label = (idx+1)+''
            marker.onEvent('click', function(e) {
                e.stopPropagation()
                //props.poiClick(e, marker.id)
                selectedPoi(marker.id)
                infoWindowOpen2(marker)
            });
            currNearMarkers.current.push(marker)
        });
    }

    const mapClear = ()=>{
        setSelectedTbt(null)
        infoWindowOpen(null)
        if(!currRoutes.current){
            return
        }
        for (let [key, route] of Object.entries(currRoutes.current)) {
            route['polyline'].setMap(null)
            if(outCenterDraw.current){
                route['polyline_outline'].setMap(null)
                route['polyline_centerLine'].setMap(null)
            }
            route['markers'].some((marker) => {
                marker.setMap(null)
            })
        }
    }

    const nearPoiClear = ()=>{
        infoWindowOpen2(null)
        if(!currNearMarkers.current){
            return
        }
        for (let [key, marker] of Object.entries(currNearMarkers.current)) {
            marker.setMap(null)
        }
    }

    const infoWindowOpen = (marker)=>{
        props.infoWindow(marker)
    }

    const infoWindowOpen2 = (marker)=>{
        props.infoWindow2(marker)
    }

    const tbtMapFocus = ()=>{
        props.tbtInfoWindowShow(currRoutes.current['rpType_' + rpOpts.rpType]['markers'][selectedTbt])
    }

    const poiMapFocus = ()=>{
        if(!currNearMarkers.current) return
        var matchMarker = null
        currNearMarkers.current.forEach((marker, idx) => {
            marker.setZIndex(841683);
            marker.elements.upper_overlay_pane[0].children[0].children[0].className='markerBg_custom'
            if(marker.id == selectedId){
                //matchMarker = currMaker.current = marker
                matchMarker = marker
                marker.elements.upper_overlay_pane[0].children[0].children[0].className='markerBg_custom selected number'
                marker.setZIndex(ollehModule.maps.overlay.BaseOverlay.MAX_ZINDEX);
            }
        });
        if(!matchMarker){
            return
        }
        var boundTimer
        boundTimer = setInterval(function() {
            clearInterval(boundTimer);
            let position = matchMarker.getPosition();
            let center = ktMapIns.getCenter()
            center.x = position.x
            center.y = position.y
            ktMapIns.setCenter(center);
            if(ktMapIns.getZoom()<11){
                ktMapIns.setZoom(11);
            }
            infoWindowOpen2(matchMarker)
        },50);
    }

    return ('');
}

export default RPProcess